import * as React from 'react';

function AvaxLogo(props) {
  return (
    <svg
      viewBox="0 0 750 750"
      width={props.width || '20'}
      height={props.height || '20'}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M323.652 647c178.664 0 323.5-144.836 323.5-323.5S502.316 0 323.652 0 .152 144.836.152 323.5 144.988 647 323.652 647Zm-97.747-176.94h-75.89c-17.993 0-26.99 0-32.378-3.485a21.7 21.7 0 0 1-9.886-17.003c-.361-6.403 4.095-14.21 13.007-29.822l.004-.006 166.157-291.089c9.043-15.844 13.565-23.766 19.319-26.715a21.743 21.743 0 0 1 19.806-.014c5.758 2.94 10.291 10.856 19.357 26.686l38.322 66.908.001.002c6.593 11.51 9.889 17.266 11.339 23.338a43.381 43.381 0 0 1 .009 20.109c-1.444 6.074-4.736 11.834-11.32 23.351l-99.36 173.819c-6.679 11.686-10.019 17.529-14.595 21.896a43.482 43.482 0 0 1-17.623 10.222c-6.066 1.803-12.8 1.803-26.269 1.803Zm270.753 0h-87.986c-18.156 0-27.235 0-32.64-3.515a21.703 21.703 0 0 1-9.848-17.116c-.32-6.434 4.249-14.274 13.387-29.95l43.92-75.352c9.023-15.478 13.535-23.217 19.246-26.116a21.746 21.746 0 0 1 19.65-.015c5.717 2.89 10.238 10.623 19.281 26.086l.002.005 44.066 75.35c9.173 15.686 13.759 23.53 13.446 29.969a21.708 21.708 0 0 1-9.843 17.135c-5.405 3.519-14.497 3.519-32.681 3.519Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default AvaxLogo;
